import { convertDateToIcsFileFormat, createFullDateValue } from '../utils/date-utils'
import { createIcsFileText, createIcsFileEventText } from '../utils/ics-utils'

class Introduction {
  constructor(introEl) {
    this.target = introEl
    this.icsDownloadParent = this.target.querySelector('.introduction-event-detail__download-link')
    this.icsDownloadButton = this.icsDownloadParent.querySelector('a')

    this.createIcsFile()
  }

  createIcsFile() {
    const {
      isotime,
      title,
      shortinfo,
      host,
      place,
      istimeplacehidden,
    } = this.icsDownloadParent.dataset

    const time = new Date(isotime.trim())

    const icsEventText = createIcsFileEventText({
      start: convertDateToIcsFileFormat(time),
      summary: title,
      description: this.createEventDescription({
        shortInfo: shortinfo,
        host,
        time,
        place,
        isTimePlaceHidden: parseInt(istimeplacehidden),
      }),
      uid: btoa(time.toString() + Math.random()),
    })
    const icsFileText = createIcsFileText(icsEventText)

    const icsFileData = new File([icsFileText], { type: 'text/plain' })

    this.icsFileURL = window.URL.createObjectURL(icsFileData)

    this.icsDownloadButton.href = this.icsFileURL
  }

  /**
   * Create event description text to input it as ics file summary
   * @param {Object} eventInfo
   * @param {String} eventInfo.shortInfo
   * @param {String} eventInfo.host
   * @param {Date} eventInfo.time
   * @param {String} eventInfo.place
   * @param {Boolean} eventInfo.isTimePlaceHidden
   * @returns
   */
  createEventDescription({ shortInfo, host, time, place, isTimePlaceHidden }) {
    let description = ''

    if (host) description += host + ' '
    if (shortInfo && isTimePlaceHidden) description += shortInfo + ' '
    if (time && !isTimePlaceHidden)
      description +=
        `${createFullDateValue(time.getUTCHours())}:${createFullDateValue(time.getUTCMinutes())}` +
        ' '
    if (place && !isTimePlaceHidden) description += place + ' '

    description = description.replace(/\s+\s/g, ' ')

    return description
  }
}

export default {
  init() {
    const introEls = document.querySelectorAll('.introduction.introduction-event-detail')

    if (introEls.length) {
      introEls.forEach(introEl => new Introduction(introEl))
    }
  },
}
